import Konva from 'konva';
import { SEATING_CONSTANTS, SEATING_COLORS, SEATING_STYLES } from '../constants/seatingConstants';

/** Prisma/API Json object veya eski string layout */
export const parseLayoutJson = (value) => {
  if (value == null || value === '') return value;
  if (typeof value === 'string') return JSON.parse(value);
  return JSON.parse(JSON.stringify(value));
};

export const findIndexWithTickets = (stageJSON) => {
  let useIndex = 0;
  let bestGroupLayer = 0;
  let bestGroupCount = -1;

  stageJSON.children.forEach((e, i) => {
    if (!e.children) return;
    const groupCount = e.children.filter((a) => a.className === 'Group').length;
    if (groupCount > bestGroupCount) {
      bestGroupCount = groupCount;
      bestGroupLayer = i;
    }
    e.children.forEach((a) => {
      if (a.attrs && (a.attrs.tickets || a.attrs.ticket)) {
        useIndex = i;
      }
    });
  });

  // Ticket yoksa en cok Group iceren layer (koltuklar)
  if (bestGroupCount > 0 && useIndex === 0 && bestGroupLayer !== 0) {
    return bestGroupLayer;
  }
  return useIndex;
};

export const stringToColour = (idString) => {
  let idNumber = parseInt(idString, 36);
  let red = (idNumber & 0xff0000) >> 16;
  let green = (idNumber & 0x00ff00) >> 8;
  let blue = idNumber & 0x0000ff;
  let luminance = (0.299 * red + 0.587 * green + 0.114 * blue) / 255;

  if (luminance > 0.7) {
    red = Math.floor(red * 0.7);
    green = Math.floor(green * 0.7);
    blue = Math.floor(blue * 0.7);
  }

  return '#' + ((1 << 24) + (red << 16) + (green << 8) + blue).toString(16).slice(1);
};

export const createSeatShape = (x, y) => {
  return new Konva.Rect({
    name: 'drawn',
    width: SEATING_CONSTANTS.BLOCK_SNAP_SIZE,
    height: SEATING_CONSTANTS.BLOCK_SNAP_SIZE,
    scaleX: 0.9,
    scaleY: 0.9,
    x: 2,
    y: 2,
    fill: SEATING_COLORS.DEFAULT_SEAT,
    stroke: 'black',
    strokeWidth: 1.5,
  });
};

export const createSeatLabel = (text) => {
  return new Konva.Text({
    text: text,
    fontSize: 12,
    x: 7,
    y: 7,
    fontFamily: 'Arial',
    fill: SEATING_COLORS.DEFAULT_TEXT,
  });
};

export const createAreaShape = (type, size, heightRectangle = null) => {
  if (type === 'circle') {
    return new Konva.Circle({
      name: 'drawn',
      radius: size,
      x: 0,
      y: 0,
      fill: SEATING_COLORS.TRANSPARENT,
      stroke: 'black',
      strokeWidth: 1.5,
    });
  }

  if (type === 'rectangle') {
    return new Konva.Rect({
      name: 'drawn',
      width: size,
      height: heightRectangle,
      x: 0,
      y: 0,
      fill: SEATING_COLORS.TRANSPARENT,
      stroke: 'black',
      strokeWidth: 1.5,
    });
  }

  return null;
};

export const createShadowRect = () => {
  return new Konva.Rect({
    x: 0,
    y: 0,
    width: SEATING_CONSTANTS.BLOCK_SNAP_SIZE,
    height: SEATING_CONSTANTS.BLOCK_SNAP_SIZE,
    ...SEATING_STYLES.SHADOW_RECT,
  });
};

export const createSelectionRect = (x, y) => {
  return new Konva.Rect({
    x: x,
    y: y,
    width: 0,
    height: 0,
    ...SEATING_STYLES.SELECTION_RECT,
    listening: false,
  });
};

export const createGridLayer = (width, height) => {
  const gridLayer = new Konva.Layer();
  const padding = SEATING_CONSTANTS.BLOCK_SNAP_SIZE;

  // Vertical lines
  for (let i = 0; i < width / padding; i++) {
    gridLayer.add(
      new Konva.Line({
        points: [Math.round(i * padding) + 0.5, 0, Math.round(i * padding) + 0.5, height],
        ...SEATING_STYLES.GRID_LINE,
      }),
    );
  }

  // Horizontal lines
  for (let j = 0; j < height / padding; j++) {
    gridLayer.add(
      new Konva.Line({
        points: [0, Math.round(j * padding), width, Math.round(j * padding)],
        ...SEATING_STYLES.GRID_LINE_HORIZONTAL,
      }),
    );
  }

  return gridLayer;
};

export const getNextLabelNumber = (layerRef) => {
  const lastGroup = layerRef.current?.find('Group').pop();
  if (lastGroup) {
    const labelNum = parseInt(lastGroup.children[1].attrs.text) || 0;
    return (labelNum + 1).toString();
  }
  return '1';
};

export const snapToGrid = (value, snapSize = SEATING_CONSTANTS.BLOCK_SNAP_SIZE) => {
  return Math.round(value / snapSize) * snapSize;
};

export const handleScrollContainer = (e, scrollContainer) => {
  if (!scrollContainer) return;

  const containerRect = scrollContainer.getBoundingClientRect();
  const scrollBy = 30;

  if (containerRect.left > 0 && e.evt.clientX < containerRect.left + 50) {
    scrollContainer.scrollLeft -= scrollBy;
  }
  if (e.evt.clientX > window.innerWidth - 50) {
    scrollContainer.scrollLeft += scrollBy;
  }
  if (containerRect.top > 0 && e.evt.clientY < containerRect.top + 50) {
    scrollContainer.scrollTop -= scrollBy;
  }
  if (e.evt.clientY > window.innerHeight - 50) {
    scrollContainer.scrollTop += scrollBy;
  }
};
